export const gameConfig = {
  simulationHz: 60,
  maxFrameDelta: 0.25,
  sector: {
    radius: 28000
  },
  playerShip: {
    acceleration: 64,
    maxSpeed: 130,
    damping: 0.99,
    maxRoll: 0.6,
    rollResponse: 3.5,
    mouseSensitivity: 0.0018,
    maxPitch: Math.PI * 0.45,
    turnResponse: 6.5,
    bankAmount: 0.45,
    maxBank: 0.35
  },
  camera: {
    follow: {
      offsetBehind: 15,
      offsetUp: 5.5,
      lookAhead: 18,
      positionLerp: 5,
      lookLerp: 7,
      lookHeight: 2.2
    }
  }
} as const;
